import AmpersandStateExtended from '../../gd-model/ampersand-state-extended';

import GDTask from '../task/gd-task';

import Moment from 'moment';
import DatetimeUtils from 'core/gd/utils/datetime-utils';
import {MyWorkType} from "app/home/my-work/common/model/@const";

const MyWorkModel = AmpersandStateExtended.extend({

    idAttribute: 'id',

    props: {
        id: 'string',
        userId: 'string',
        type: 'number',

        fromUserId: 'string',
        projectId: 'string',
        companyId: 'string',

        task: 'object',
        event: 'object',
        report: 'object',
        reminder: 'object',

        dateCreated: 'gd-datetime',
        position: 'number',

        scheduleStatus: 'number',
        scheduleDate: 'gd-date',

        deadline: 'gd-date',
        startDate: 'gd-date',
        endDate: 'gd-date',

        isNew: 'boolean',
        properties: 'object'
    },

    derived: {
        title: {
            deps: ['task', 'event','report'],
            fn: function () {
                if (this.task) return this.task.title;
                if (this.event) return this.event.title;
            }
        },
        folder: {
            deps: ['type', 'scheduleStatus', 'scheduleDate'],
            fn: function () {
                let res;
                switch (this.scheduleStatus) {
                    case gd.const.task.scheduleStatus.NOT_SCHEDULED: res = gd.const.myWork.group.INBOX; break;

                    case gd.const.task.scheduleStatus.SCHEDULED:
                        const today = Moment();

                        if (!this.scheduleDate /*patch potential issues*/ || this.scheduleDate.isSame(today,'day') || this.scheduleDate.isBefore(today,'day')) {
                            res = gd.const.myWork.group.TODAY;
                        } else {
                            res = gd.const.myWork.group.DAY + this.scheduleDate.format("YYYY-MM-DD");
                        }
                        break;

                    case gd.const.task.scheduleStatus.SOMEDAY:
                    default:                                        res = gd.const.myWork.group.SOMEDAY; break;
                }

                return res;
            }
        }
    },

    pastdueDays() {
        const { SCHEDULED } = gd.const.task.scheduleStatus;

        let res = 0;

        if (this.scheduleStatus === SCHEDULED) {
            const today = Moment();

            switch (this.type) {
                case gd.const.myWork.type.TASK:
                    const { deadline, endDate } = this.task;
                    if ((!!deadline && Moment(deadline).isBefore(today,'day'))) {
                        res = today.diff(Moment(deadline), 'days');
                    } else if (!!endDate && Moment(endDate).isBefore(today,'day')) {
                        res = today.diff(Moment(endDate), 'days');
                    } else if (this.scheduleDate.isBefore(today,'day')) {
                        res = today.diff(this.scheduleDate, 'days');
                    }
                    break;

                default:
                    res = this.scheduleDate.isBefore(today,'day') ? today.diff(this.scheduleDate, 'days') : 0;
                    break;
            }
        }

        return res;
    },

    reset(data) {
        switch (this.type) {
            case gd.const.myWork.type.TASK:
                this.task.priority =        data.task.priority;
                this.task.title =           data.task.title;
                this.task.taskTypeId =      data.task.taskTypeId;
                this.task.projectId =       data.task.projectId;
                this.task.deadline =        data.task.deadline;
                this.task.startDate =       data.task.startDate;
                this.task.endDate =         data.task.endDate;
                this.task.scheduleStatus =  data.task.scheduleStatus;
                this.task.scheduleDate =    data.task.scheduleDate;
                this.task.shortId =         data.task.shortId;
                this.task.statusId =        data.task.statusId;

                this.set({
                    position:       data.position,
                    scheduleStatus: data.task.scheduleStatus,
                    scheduleDate:   data.task.scheduleStatus === gd.const.task.scheduleStatus.SCHEDULED ? DatetimeUtils.dateToMoment(data.task.scheduleDate) : null,
                    deadline:       data.task.deadline,
                    startDate:      data.task.startDate,
                    endDate:        data.task.endDate,
                    task:           this.task,
                    isNew:          data.isNew,
                },{silent:false});
                break;

            case gd.const.myWork.type.EVENT:
                this.set({
                    position: data.position,
                    scheduleDate: DatetimeUtils.dateToMoment(data.event.startDate),
                    event: data.event
                },{silent:false});
                break;

            case gd.const.myWork.type.REMINDER:
                this.set({
                    position: data.position,
                    scheduleDate: DatetimeUtils.datetimeToMoment(data.reminder.scheduleMoment), //!!! this should be date ???
                    reminder: data.reminder
                },{silent:false});
                break;

            case gd.const.myWork.type.TODO:
                this.set({
                    position: data.position,
                    scheduleDate: DatetimeUtils.datetimeToMoment(data.properties.scheduleMoment), //!!! this should be date ???
                },{silent:false});
                break;

            default:
                console.error("my work reset unknown type");
                break;
        }
    },

    moveToFolder(folder){
        if (this.folder === folder) return;

        switch (folder) {
            case gd.const.myWork.group.INBOX:   this.set({scheduleStatus: gd.const.task.scheduleStatus.NOT_SCHEDULED,   scheduleDate: null,                         position: 0}); break;
            case gd.const.myWork.group.TODAY:   this.set({scheduleStatus: gd.const.task.scheduleStatus.SCHEDULED,       scheduleDate: Moment(),                     position: 0}); break;
            case gd.const.myWork.group.SOMEDAY: this.set({scheduleStatus: gd.const.task.scheduleStatus.SOMEDAY,         scheduleDate: null,                         position: 0}); break;

            default:
                if (folder.substring(0, 4) === gd.const.myWork.group.DAY)
                                                this.set({scheduleStatus: gd.const.task.scheduleStatus.SCHEDULED,       scheduleDate: Moment(folder.substring(4)),  position: 0}); break;
        }

        gd.bus.triggerEvent('my-work-model:change-schedule', this);
    },

    getTask(){
        const { task, fromUserId, dateCreated } = this;

        return new GDTask({
            id: task.id,
            shortId: task.shortId,
            title: task.title,
            priority: task.priority,
            cameFromUser: gd.session.users.get(fromUserId),
            projectId: task.projectId,
            project: gd.session.projects.get(task.projectId),
            taskTypeId: task.taskTypeId,

            dateCreated: dateCreated,

            scheduleStatus: this.scheduleStatus,
            scheduleDate: this.scheduleDate
        },{parse:true});
    },

    parse(obj) {

        switch (obj.type) {



            case gd.const.myWork.type.TASK:
                obj.scheduleDate = obj.task.scheduleStatus === gd.const.task.scheduleStatus.SCHEDULED ? DatetimeUtils.dateToMoment(obj.task.scheduleDate) : null;
                obj.scheduleStatus = obj.task.scheduleStatus;
                obj.projectId = obj.task.projectId;
                obj.companyId = obj.task.companyId;

                obj.deadline = obj.task.deadline;
                obj.startDate = obj.task.startDate;
                obj.endDate = obj.task.endDate;
                break;

            case gd.const.myWork.type.EVENT:
                obj.scheduleDate = DatetimeUtils.dateToMoment(obj.event.startDate);
                obj.scheduleStatus = gd.const.task.scheduleStatus.SCHEDULED;
                obj.projectId = obj.event.projectId;
                break;

            case  gd.const.myWork.type.REPORT:
                obj.scheduleStatus = gd.const.task.scheduleStatus.NOT_SCHEDULED;
                break;

            case  gd.const.myWork.type.REMINDER:
                obj.scheduleDate = DatetimeUtils.datetimeToMoment(obj.reminder.scheduleMoment); // shoul be scheduleDate ???
                obj.scheduleStatus = obj.reminder.scheduleStatus;
                break;

            case  MyWorkType.RATE_EXPERIENCE:
                // obj.scheduleDate = null;
                obj.scheduleStatus = gd.const.task.scheduleStatus.NOT_SCHEDULED;
                break;

            case MyWorkType.TODO:
                console.log("need to to", obj)
                obj.scheduleDate = obj.properties.scheduleMoment ? DatetimeUtils.datetimeToMoment(obj.properties.scheduleMoment) : null
                break

            default:
                console.error("unknown my work type type=", obj.type, "obj=",obj);
        }

        return obj;
    }
});

module.exports = MyWorkModel;